import type { TextWidgetData } from '@/types';

interface TextWidgetProps {
  data: TextWidgetData;
}

const TextWidget = ({ data }: TextWidgetProps) => {
  return (
    <div className="p-4 bg-white dark:bg-dark-800 rounded-2xl shadow-soft dark:shadow-none">
      <p className="text-dark-800 dark:text-gray-100 whitespace-pre-wrap">{data.content}</p>
    </div>
  );
};

export default TextWidget;
